<template>
    <div class="all-reply-wrapper" ref="scrollboxWrapper" :class="{'box-overflow-hidden':callQuitWarning || callCommentInput}">
        <div class='all-reply' :class="{'all-reply-padding-set': KBTitle}" ref="scrollbox" v-if="ajaxDone">
            <!-- 全部回复显示 -->
            <div class="reply-title reply-item">
                <div class="comment-head-image">
                    <img :src="mainCommentInfo.HeadImage || '/static/images/default.png' " @error="$imgErr">
                </div>
                <div class="comment-info">
                    <div class='comment-head'>
                        <div class='comment-head-name'>{{mainCommentInfo.Name}}</div>
                        <div class="knowledge-expert" v-if="mainCommentInfo.Identity == 1">
                            <img src="/static/images/knowledge_expert.png" alt="">
                        </div>
                        <!--<div class="comment-head-delete" @click.stop="deleteBtnClick(mainCommentInfo.Id,index)" v-if="mainCommentInfo.IsAdmin && !mainCommentInfo.IsDel">删除</div>-->
                    </div>
                    <div class='comment-time'>{{ $calcTime(mainCommentInfo.CreateDate + '000') }}</div>
                    <div class="comment-content" v-if="!mainCommentInfo.IsDel && mainCommentInfo.Comment && mainCommentInfo.Comment.length" v-text="mainCommentInfo.Comment"></div>
                    <div class='content-delete-tip' v-if="mainCommentInfo.IsDel">
                        <span class='left-cane'></span>
                        <span class='delete-tip'>评论已删除</span>
                        <span class='right-cane'></span>
                    </div>
                    <div class="comment-attachment" v-if="!mainCommentInfo.IsDel && mainCommentInfo && mainCommentInfo.AttachList">
                        <div class="source-img-wrapper" @click.stop="showImg(index,mainCommentInfo.AttachList)" v-if="index < 4" v-for="(attachment,index) in mainCommentInfo.AttachList">
                            <img class="source-img" :src="attachment" @error="$commentImgErr">
                        </div>
                    </div>
                </div>

            </div>


            <!-- 子评论列表区域 -->
            <div class='reply-list'>
                <div class="reply-list-title">全部回复({{ totalReplyCount }})</div>
                <div class="reply-item" :class="{'comment-mark': replys.CommentId == subCommentId}" v-if="!replys.IsDel" v-for="(replys,index) in replyList" @click="addComment(replys)">
                    <div class="comment-head-image">
                        <img :src="replys.HeadImage || '/static/images/default.png' " @error="$imgErr">
                    </div>
                    <div class="comment-info">
                        <div class='comment-head'>
                            <div class='comment-head-name'>{{replys.ReplyBy}}</div>
                            <div class="knowledge-expert" v-if="replys.Identity == 1">
                                <img src="/static/images/knowledge_expert.png" alt="">
                            </div>
                            <div class="comment-head-delete" @click.stop="deleteBtnClick(replys.CommentId,index)" v-if="replys.IsAdmin && !replys.IsDel">删除</div>
                        </div>
                        <div class='comment-time'>{{ $calcTime(replys.ReplyTime + '000') }}</div>
                        <!-- 全部修改成了 回复XX: 不通过域账号来判断 -->
                        <div class="comment-content" >
                            回复 <span>{{ replys.ReplyTo }}</span>：{{replys.ReplyMessage}}
                        </div>
                        <!--回复人不是主评论人-->
                        <div class="comment-content" v-if="false && replys.ReplyMessage.length && (replys.ReplyToADAccount !== mainCommentInfo.ADAccount || replys.ReplyToADAccount !==  replys.ReplyADAccount)">
                            回复 <span>{{ replys.ReplyTo }}</span>：{{replys.ReplyMessage}}
                        </div>
                        <!--回复人是主评论人-->
                        <div class="comment-content" v-if="false && replys.ReplyMessage && replys.ReplyMessage.length && !(replys.ReplyToADAccount !== mainCommentInfo.ADAccount || replys.ReplyToADAccount !==  replys.ReplyADAccount)">
                            {{replys.ReplyMessage}}
                        </div>
                        <div class="comment-attachment" v-if="replys.AttachList && replys.AttachList.length">
                            <div class="source-img-wrapper" @click.stop="showImg(index,replys.AttachList)" v-if="index < 3" v-for="(attachment,index) in replys.AttachList">
                                <img class="source-img" :src="attachment"   @error="$commentImgErr">
                            </div>
                        </div>
                    </div>
                </div>

                <div class='more-leave' v-if="replyList && totalReplyCount>10&&checkMoreComment">
                    <div class='more-leave-btn' @click="checkMoreCommentClick">查看更多评论</div>
                </div>
                <loading-more></loading-more>
            </div>
        </div>

        <div class="back-to-k-bar" v-if="ajaxDone && KBTitle" @click="goDetail">
            <span>{{ KBTitle }}</span><span>查看原文</span>
        </div>
        <div class="answer-bar" v-if="ajaxDone && (!mainCommentInfo.IsDel || replyList.length)">
            <div class='answer-input' @click="addComment(mainCommentInfo, matchedReply)">回复 {{ replyPlaceHolder }}:</div>
            <!-- <div class='answer-input' @click="addComment(mainCommentInfo)">回复 {{ mainCommentInfo.Name}}:</div> -->
        </div>


        <!-- 问答输入框 -->
        <leave-question v-if="callCommentInput && $route.name === 'replyList'" :commentInfo="commentInfo" @successPush="successPush"></leave-question>

        <!-- 评论 删除 提醒 -->
        <quit-message v-if='callDeleteWarning' :mask="'mask'" :messageTitle="delMessageTitle" :messageText="delMessageText" :queryBtn="delQueryBtn" @closeQuitWarning='closeDelWarning' @eventContinue="deleteContinue"></quit-message>

        <!-- 评论输入有内容时的 退出路由 提醒 -->
        <quit-message v-if='callQuitWarning' :messageTitle="messageTitle" :messageText="messageText" :queryBtn="queryBtn" @closeQuitWarning='closeQuitWarning' @eventContinue="eventContinue"></quit-message>

        <!-- 无权限页面 -->
        <unauthorize v-if="callUnauthorize" :unauthorizeType="unauthorizeType"></unauthorize>

        <!-- 图片预览 -->
        <photo-package v-if="sourceList && sourceList.length" :list="sourceList" :options="options" selector=".source-img" @on-close="closeHandler" ref="sourcePreview">
        </photo-package>

        <!-- 水印组件 -->
        <water-mark ref="watermark"></water-mark>
    </div>
</template>

<script>
import leaveList from '@/components/leaveList'
import waterMark from '@/components/waterMark'
import unauthorize from '@/views/404/403.vue'
import nioToast from '@/components/toast'
import quitMessage from '@/components/quitMessage'
import leaveQuestion from '@/components/leaveQuestion'
import loadingMore from '@/components/loadingMore'
import {COMMENTS, SEARCH} from '../api'
import PhotoPackage from 'photoswipe-package'

export default {
    name: 'replyList',
    components: {
        leaveList, unauthorize, nioToast, quitMessage, leaveQuestion, loadingMore,PhotoPackage,waterMark
    },
    data() {
        return {
            ajaxDone: false,
            callUnauthorize: false,
            unauthorizeType: '401',

            KBTitle: '',
            KBType: 1,
            mainCommentInfo: '', //主评论信息
            replyList: [],   //回复列表信息
            commentInfo: '', //用于传入输入框的评论人信息， 如果点击底部按钮弹出输入框则传入mainCommentInfo,如果点击列表弹出输入框则传入replys
            // 退出提醒
            callQuitWarning: false,  //用于显示退出确认弹窗
            toRouterPath: '',     //用于保存想退出当前页面并前往的路由
            // 退出确认弹窗的内容以及按钮文字
            messageTitle: '是否继续退出',
            messageText: '未提交内容将不会被保存,是否继续退出?',
            queryBtn: '继续退出',
            //删除提醒
            callDeleteWarning: false,  //用于显示确认弹窗
            // 删除确认弹窗的内容以及按钮文字
            delMessageTitle: '确认删除',
            delMessageText: '确认删除该条评论么',
            delQueryBtn: '删除',
            deleteIndex: '',
            deleteId: '',

            //分页
            replyPageIndex: 1,
            replyPageSize: 100,
            totalReplyCount: 1, //一共多少条回复
            checkMoreComment: true,//是否显示查看更多  点击后直接调用滚动加载更多并隐藏查看更多
            leavePrevAjaxEnd: true,//加载更多是否完成


            // 图片预览组件
            sourceList:null,
            options: {
                loop: false,
                zoomEl: true,
                fullscreenEl: false,
                tapToClose: true
            },
            matchedReply: null  // 匹配到的那条回复

        }
    },
    computed: {
        callCommentInput() {
            return this.$store.getters.GET_CallCommentInput
        },
        inputContent() {
            return this.$store.getters.GET_InputContent
        },
        subCommentId() {
            return this.$route.params.subCommentId || ''
        },
        replyPlaceHolder() {
            // 取匹配到的那条回复者，没有匹配到就取主评论者
            return this.matchedReply ? this.matchedReply.ReplyBy : this.mainCommentInfo.Name
        }
    },
    mounted() {
        // this.$route.params.subCommentId ? this.findSubCommentId() : this.initReplyList();
        this.initReplyList()
    },
    methods: {
        getDetail() {
            if (this.KBType == 1) {
                SEARCH.GetKnowledgeDetail({
                    KBInfoId: this.$route.params.uuid.split('&')[0]
                }).then((res) => {
                    if (res.Code == 200) this.KBTitle = res.Data.Title
                })
            } else {
                SEARCH.GetFaqDetail({
                    KBInfoId: this.$route.params.uuid.split('&')[0]
                }).then((res) => {
                    if (res.Code == 200) this.KBTitle = res.Data.Question
                })
            }

        },
        goDetail() {
            this.$router.push({name: this.KBType === 1 ? 'knowledge' : 'faq', params: {uuid: this.$route.params.uuid.split('&')[0]}})
        },
        //初始化回复列表信息
        initReplyList() {
            COMMENTS.GetReplyList({
                "CommentId": this.$route.params.commentId,
                "PageIndex": this.replyPageIndex,
                "PageSize": this.replyPageSize
            }).then((res) => {
                if (res.Code == 200 && res.Data) {
                    this.mainCommentInfo = res.Data.Main
                    this.totalReplyCount = res.Data.TotalReplyCount
                    this.replyList = res.Data.ReplyList || []
                    this.checkMoreComment = !(this.totalReplyCount <= this.replyPageSize)
                    // 1 - knowledge
                    this.KBType = res.Data.Main.Type
                    this.getDetail()

                    // 点击【消息页面二级评论】进入 会传入matchCommentId
                    if (this.$route.params.matchCommentId) {
                        // 匹配replyList中Id一样的那条回复
                        let tempArr = this.replyList.filter( (list) => {
                            return list.CommentId === this.$route.params.matchCommentId
                        }) || []
                        this.matchedReply = tempArr[0]
                        console.log(222, this.matchedReply.ReplyMessage)
                    } else {
                        console.log('主评论。。。')
                    }

                    this.ajaxDone = true

                    setTimeout(()=>{
                        this.$refs.scrollboxWrapper.scrollTop = 0
                    },500)
                } else if (res.Code == 401) {
                    this.unauthorizeType = '401'
                    this.callUnauthorize = true
                } else if (res.Code == 404) {
                    this.unauthorizeType = '404'
                    this.callUnauthorize = true
                }
                this.scrollToMatched()
            }).catch((error) => {
            })
        },
        //如果有ID，定位到目标位置
        scrollToMatched() {
            setTimeout(() => {
                if (document.querySelector('.comment-mark')) document.querySelector('.comment-mark').scrollIntoViewIfNeeded(true);
            }, 300)
        },
        // 滚动加载
        scrollHandler() {
            let scrollTop = this.$refs.scrollboxWrapper.scrollTop
            let visible_h = this.$refs.scrollboxWrapper.clientHeight
            let scrollBox_h = this.$refs.scrollBox.clientHeight
            if (scrollTop + visible_h >= scrollBox_h) {
                this.loadMoreReply()
            }
        },
        checkMoreCommentClick() {
            this.checkMoreComment = false
            this.loadMoreReply()
        },
        //加载更多数据
        loadMoreReply() {
            // 当  查看更多按钮在的时候   禁止滚动加载
            if (this.checkMoreComment) return
            // 当  查看更多按钮消失后，  当 当前页数 大于等于  总页数时，  禁止滚动加载
            if (this.replyPageIndex >= Math.ceil(this.totalReplyCount / this.replyPageSize)) return
            // 当上一次滚动加载未完成时，禁止滚动加载
            if (!this.leavePrevAjaxEnd) return

            this.leavePrevAjaxEnd = false;
            this.$store.commit('SET_LOADING_POSITION', 'bottom')

            COMMENTS.GetReplyList({
                "CommentId": this.$route.params.commentId,
                "PageIndex": ++this.replyPageIndex,
                "PageSize": this.replyPageSize
            }).then((res) => {
                if (res.Code == 200 && res.Data) {
                    this.$store.commit('SET_LOADING_POSITION', 'middle')
                    this.mainCommentInfo = res.Data.Main
                    this.totalReplyCount = res.Data.TotalReplyCount
                    this.replyList = this.replyList.concat(res.Data.ReplyList)
                }
                this.leavePrevAjaxEnd = true
                this.$store.commit('SET_LOADING_POSITION', 'middle')
            }).catch((error) => {
                this.leavePrevAjaxEnd = true
                this.$store.commit('SET_LOADING_POSITION', 'middle')
            })

        },
        // 添加子评论，打开输入框弹窗
        addComment(commentInfo, matchedReply) {
            this.commentInfo = matchedReply ? matchedReply : commentInfo
            // this.commentInfo = commentInfo
            this.$store.commit('SET_InputPlaceholder', '回复 ' + (this.commentInfo.Name || this.commentInfo.ReplyBy) + ':')
            this.$store.commit('SET_CallCommentInput', true)
        },
        //发布成功，将新回复加到列表中
        successPush(answerSomeInfo) {
            // 初始化新回复
            let replyerInfo = {
                AttachList: answerSomeInfo.AttachList,
                CommentId: answerSomeInfo.CommentId,
                HeadImage: answerSomeInfo.HeadImage,
                Identity: answerSomeInfo.Identity,
                IsAdmin: true,
                IsDel: false,
                KBInfoId: '', //用不到这个值，不赋值也无所谓
                MainCommentId: answerSomeInfo.MainCommentId,
                ReplyADAccount: answerSomeInfo.ADAccount,
                ReplyBy: answerSomeInfo.Name,
                ReplyMessage: answerSomeInfo.Comment,
                ReplyTime: answerSomeInfo.CreateTime,
                ReplyTo: this.commentInfo.Name || this.commentInfo.ReplyBy,
                ReplyToADAccount: this.commentInfo.ADAccount || this.commentInfo.ReplyADAccount,
            }
            this.replyList.push(replyerInfo)
            this.callDeleteWarning = false
            this.totalReplyCount++
            this.$store.commit('SET_InputContent', false)
            this.$store.commit('SET_CallCommentInput', false)
        },
        //点击删除按钮
        deleteBtnClick(id, index) {
            this.deleteIndex = index
            this.deleteId = id
            this.callDeleteWarning = true
        },
        //关闭删除确认
        closeDelWarning() {
            this.callDeleteWarning = false
        },
        //确认删除子评论
        deleteContinue() {
            // 发送删除请求
            COMMENTS.DelComment({
                "CommentId": this.deleteId
            }).then((res) => {
                if (res.Code == 200) {
                    this.callDeleteWarning = false
                    this.replyList.splice(this.deleteIndex, 1)
                    this.totalReplyCount--
                }
            })
        },

        //退出确认
        closeQuitWarning() {
            // 关闭确认框
            this.callQuitWarning = false
        },
        //继续退出
        eventContinue() {
            // 关闭输入框，清除掉 inputContent ，所以继续操作的时候不会阻止路由跳转了
            this.$store.commit('SET_InputContent', false)
            this.$store.commit('SET_CallCommentInput', false)
            // 关闭确认框
            this.callQuitWarning = false
            // 跳转路由
            setTimeout(() => {
                this.$router.push(this.toRouterPath)
            }, 300)
        },

        showImg(index,sourceList) {
            // 图片预览
            let imgList = sourceList.map((e)=>{
                return {
                    // transfer key named `FileUrl` to `src`
                    src: e,
                    FileName: e,
                    FileType: 'jpg'
                }
            })
            this.sourceList = imgList
            this.$nextTick(()=>{
                this.$refs.sourcePreview.show(index)
                this.$refs.watermark && this.$refs.watermark.initWaterMark(true)
            })
        },
        closeHandler(){
            this.sourceList = [];
        }
    },
    beforeRouteLeave(to, from, next) {
        //返回路由时  先判断是否有输入过评论内容或上传过图片
        if (this.inputContent) {
            //如果有内容则不退出路由并弹出退出评论确认框
            this.callQuitWarning = true
            this.toRouterPath = to.path
            next(false)
        } else {
            this.$store.commit('SET_CallCommentInput', false)
            this.$store.commit('SET_InputPlaceholder', '写下我的留言或提问...')
            document.getElementById('app').removeEventListener('scroll', this.scrollHandler)
            next();
        }
    },
}
</script>

<style type="text/scss" lang='scss' scoped>

    .all-reply-wrapper {
        position: relative;
        height: 100%;
        width: 100%;
        overflow: scroll;
    }

    .box-overflow-hidden {
        overflow: hidden;
    }

    .back-to-k-bar {
        height: j(120);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 j(50);
        background-color: #fff;
        box-shadow: 0 j(5) j(20) 0 rgba(54, 60, 84, 0.05);

        span {
            &:first-child {
                width: j(480);
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: rgba(54, 60, 84, 1);
                font-size: j(32);
            }

            &:last-child {
                min-width: 50px;
                text-align: right;
                color: #00bebe;
                font-size: j(28);
            }
        }
    }

    .answer-bar {
        width: 100%;
        height: j(100);
        position: fixed;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1101;
        background: #fff;

        .answer-input {
            height: j(70);
            width: j(650);
            font-size: j(28);
            color: rgba(205, 206, 212, 1);
            background: rgba(247, 247, 248, 1);
            border-radius: 4px;
            line-height: j(70);
            text-indent: j(10);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

    }

    .reply-item {

        width: 100%;
        display: flex;
        line-height: j(32);
        box-sizing: border-box;
        position: relative;

        .comment-head-image {
            width: j(80);
            margin-right: j(20);

            img {
                height: j(80);
                width: j(80);
                border-radius: 50%;
            }
        }

        .comment-info {
            width: j(550);
        }

        .comment-head {
            height: j(45);
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: nowrap;

            .comment-head-name {
                height: 100%;
                line-height: j(45);
                font-size: j(32);
                color: #363C54;
                padding-right: j(20);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                box-sizing: border-box;
            }

            .knowledge-expert {
                height: 100%;
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: flex-start;

                img {
                    width: j(84);
                    height: j(30);
                }
            }

            .comment-head-delete {
                min-width: 28px;
                font-size: j(24);
                color: #9B9DA9;
                margin-left: j(20);
            }
        }

        .comment-time {

            width: j(550);
            height: j(32);
            font-size: j(24);
            color: #9B9DA9;
        }

        .comment-content {
            margin-top: j(14);
            line-height: j(42);
            font-size: j(30);
            color: #363C54;
            word-wrap: break-word;
            word-break: break-word;

            span {
                color: rgba(155, 157, 169, 1);
            }
        }

        .comment-attachment {
            margin-top: j(20);
            margin-left: j(-20);
            height: j(100);
            display: flex;
            .source-img-wrapper{
                width: j(100);
                height: j(100);
                border-radius: 3px;
                overflow: hidden;
                margin-left: j(20);
            }
            img {
                width: j(100);
                height: j(100);
                border-radius: 3px;
                pointer-events: none;
            }
        }

        .content-delete-tip {
            height: j(42);
            line-height: j(42);
            font-size: j(28);
            color: #9B9DA9;
            position: relative;

            .left-cane {
                width: j(6);
                height: j(12);

                display: inline-block;
                border-top: 1px solid #9B9DA9;
                border-left: 1px solid #9B9DA9;
                transform: scale(1.5);
                position: absolute;
                top: j(12);
            }

            .delete-tip {
                height: j(42);
                font-size: j(28);
                color: #9B9DA9;
                display: inline-block;
                margin: 0 j(5) 0 j(10);
            }

            .right-cane {
                width: j(6);
                height: j(12);
                display: inline-block;
                border-right: 1px solid #9B9DA9;
                border-bottom: 1px solid #9B9DA9;
                transform: scale(1.5);
                position: absolute;
                top: j(18);
            }
        }
    }

    .all-reply {
        padding-bottom: j(100);

        .reply-title {
            padding: j(50);

            &:after {
                content: '';
                position: absolute;
                height: 1px;
                width: j(650);
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                background-color: #F0F1F2;
            }
        }
    }

    .all-reply-padding-set {
        padding-top: j(120);
    }

    .reply-list {
        padding: j(60) j(50);

        .reply-list-title {
            font-size: j(28);
            color: #9B9DA9;
        }

        .reply-item {
            margin-top: j(40);
            padding-bottom: 0;

            .comment-info {
                border-bottom: 1px solid #F0F1F2;
                padding-bottom: j(40);
            }
        }
    }

    .more-leave {
        width: j(650);
        height: j(60);
        margin: j(50) 0;
        display: flex;
        align-items: center;
        justify-content: center;

        .more-leave-btn {
            width: j(238);
            height: j(60);
            // border: 1px solid red;
            border-radius: j(28);
            background: #F0FCFC;
            font-size: j(28);
            color: #00BCBC;
            display: flex;
            align-items: center;
            justify-content: center;
        }

    }
</style>





// WEBPACK FOOTER //
// src/views/replyList.vue